export default "__VITE_ASSET__B5tR9RwW__"